/* istanbul ignore file */

import { Carriers } from '../constants/carriers';
import lgaUri from './assets/lga.png';
import { CarrierConfig } from './carrierConfig';

export class CarrierLGA extends CarrierConfig {
  getCarrier(): Carriers {
    return Carriers.LGA;
  }
  getCarrierDisplayName(): string {
    return 'Banner Life Insurance Company';
  }
  getLabel(): string {
    return 'LGA';
  }
  supportLetterGeneration(): boolean {
    return true;
  }
  getCarrierLogo(): string {
    return lgaUri;
  }
}
